import React, { useEffect, useState } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import "./LoginModal.css";
import { handleAppError } from "utils/errorHandler";
import ButtonLoader from "./ButtonLoader";

const loginSchema = Yup.object({
  email: Yup.string()
    .trim()
    .email("Invalid email address")
    .required("Email is required"),
});

function ForgotPassword({
  show,
  handleClose,
  onSignIn = () => {},
  onForgotPassword = () => {},
}) {
  const [apiError, setApiError] = useState(null);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setApiError(null);
        console.log("Forgot password attempt with:", values);

        // Call the onForgotPassword prop with email
        // Parent will handle closing modal and showing toast
        await onForgotPassword(values.email);
        resetForm();
      } catch (error) {
        const errorMsg = handleAppError(error);
        setApiError(errorMsg);
      }
    },
  });

  useEffect(() => {
    if (show) {
      formik.resetForm();
      setApiError(null);
    }
  }, [show]);

  return (
    <Modal show={show} onHide={handleClose} centered size="open">
      <div className="p-4">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center mb-2">
          <h1 className="h4 mb-0">Forgot Password</h1>
          <button
            className="btn-close"
            onClick={handleClose}
            aria-label="Close modal"
          />
        </div>

        <p className="text-muted mb-4 login-info">
          Provide your email to receive a password reset link.
        </p>

        {/* API Error Display */}
        {apiError && (
          <div className="alert alert-danger" role="alert">
            {apiError}
          </div>
        )}

        {/* Form */}
        <Form onSubmit={formik.handleSubmit}>
          {/* Email Field */}
          <div className="mb-3">
            <Form.Label htmlFor="email" className="fw-medium">
              Email
            </Form.Label>
            <Form.Control
              type="email"
              id="resetEmail"
              placeholder="Enter your email"
              className={`bg-light ${
                formik.touched.email && formik.errors.email ? "is-invalid" : ""
              }`}
              {...formik.getFieldProps("email")}
            />
            {formik.touched.email && formik.errors.email && (
              <div className="invalid-feedback d-block">
                {formik.errors.email}
              </div>
            )}
          </div>

          <Button
            type="submit"
            disabled={formik.isSubmitting}
            className="w-100 rounded-pill py-2 mb-4"
            style={{
              background: "#FFC3F6",
              border: "none",
              color: "#000",
            }}
          >
            {formik.isSubmitting ? <ButtonLoader /> : "Forgot Password"}
          </Button>
        </Form>

        {/* Sign Up Link */}
        <div className="d-flex justify-content-center gap-2">
          <span className="text-muted">Already have an account?</span>
          <button
            type="button"
            className="btn btn-link p-0 text-decoration-none"
            style={{ color: "#ff69b4" }}
            onClick={onSignIn}
          >
            Sign In
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default ForgotPassword;
